import { render, staticRenderFns } from "./BrainTape.vue?vue&type=template&id=05dd0746&"
import script from "./BrainTape.vue?vue&type=script&lang=js&"
export * from "./BrainTape.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports